<template>
  <AdminLayout><ExportExcelTable /></AdminLayout>
</template>

<script>
import AdminLayout from '../AdminLayout.vue';
import ExportExcelTable from './ExportExcelTable.vue';

export default {
  name: 'ExportExcel',
  components: { AdminLayout, ExportExcelTable },
};
</script>
